module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "twitter.54fc3f61.svg";